import React, { useEffect, useState } from 'react';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import Calling from '../../api/Calling';
import { MdDeleteSweep } from 'react-icons/md';
import genrateCaptch from '../../components/captcha';
import { useNavigate } from 'react-router-dom';
import { MAX_FILE_SIZE_IMAGE, imageSizeExceededMessage } from '../../components/imageType'; // Import the allowed image types
import UploadButton from '../../components/ul/UploadButton';
import SaveButton from '../../components/ul/SaveButton';
import CancelButton from '../../components/ul/CancelButton';
import EditButton from '../../components/ul/EditButton';
import DeleteButton from '../../components/ul/DeleteButton';
import FileUpload from '../../components/ul/FileUpload';
import { formatView } from '../../components/formatView';
import { LuDot } from "react-icons/lu";
import ResetButton from '../../components/ul/ResetButton';
import { GrLanguage } from "react-icons/gr";
import UrlButton from '../../components/ul/UrlButton';
import ClickView from '../../components/ul/ClickView';
import NotFound from '../../components/ul/NotFound';
import formatDateTime from '../../components/formatDateTime';
import NavbarLive from './NavbarLive';
import { IoShareSocialOutline } from "react-icons/io5";

const LiveMatch = () => {
    const [loader, setLoader] = useState(false);
    const page = 1;
    const limit = 100;
    const [file, setFile] = useState(null);
    const [editData, setEditData] = useState(null);
    const [secondStoryBrand, setSecondStoryBrand] = useState(true);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const navigate = useNavigate();
    const [story, setStory] = useState({
        title: '',
        url: '',
        label: 'AD',
    });
    const imageType = [
        'image/gif',
        'image/png',
    ]

    const invalidImageMessage = 'Only GIF and PNG files are allowed. Please select an image with a valid format.'

    const [tableData, setTableData] = useState([])
    const [fileProcessing, setFileProcessing] = useState({
        image: false,
    });
    const [fileStatus, setFileStatus] = useState({
        image: null, // 'success', 'error', or null
    });
    const [editFile, setEditFile] = useState(null);
    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, []);

    const fetchData = async () => {
        setLoader(true);
        try {
            const resp = await Calling.getAllLiveMatch();
            if (resp.status) {
                setStory({ title: '', url: '' });
                setTableData(resp?.data);
                setSecondStoryBrand(resp?.liveMatch)
            } else {
                toast.error(resp?.message);
            }
        } catch (error) {
            console.error(error);
            navigate('/Error');
        } finally {
            setLoader(false);
        }
    };

    const handleChangeStory = (e) => {
        setStory({ ...story, [e.target.name]: e.target.value });
    };

    const handleChangefile = (e) => {
        const selectedFile = e.target.files[0];

        setFileProcessing({ image: true }); // Start processing

        // Validate the MIME type
        if (selectedFile && !imageType.includes(selectedFile.type)) {
            toast.error(invalidImageMessage);
            setFile(null); // Reset file if invalid
            setFileProcessing({ image: false }); // Stop processing
            setFileStatus({ image: 'error' }); // Set error status

            e.target.value = '';
            return;

        } else {
            if (selectedFile?.size > MAX_FILE_SIZE_IMAGE) {
                setFile(null);
                setFileProcessing({ image: false }); // Stop processing
                setFileStatus({ image: 'error' });
                toast.error(imageSizeExceededMessage);
                e.target.value = '';

                return;

            }
            setFile(selectedFile); // Set the file if valid
            setFileStatus({ image: 'success' }); // Set success status
            setFileProcessing({ image: false }); // Stop processing

        }
    };

    const handleEditFile = (e) => {
        const selectedFile = e.target.files[0];
        setFileProcessing({ image: true });
        if (selectedFile && !imageType.includes(selectedFile.type)) {
            toast.error(invalidImageMessage);
            setFile(null); // Reset file if invalid
            setFileStatus({ image: 'error' }); // Set error status
            e.target.value = '';
            setFileProcessing({ image: false }); // Stop processing
            return;
        } else {
            if (selectedFile?.size > MAX_FILE_SIZE_IMAGE) {
                setFile(null);
                setFileProcessing({ image: false }); // Stop processing
                setFileStatus({ image: 'error' });
                toast.error(imageSizeExceededMessage);
                e.target.value = '';
                return;
            }
            setFileProcessing({ image: false }); // Stop processing
            setFileStatus({ image: 'success' });
            setEditFile(selectedFile);
        }


    }

    const handleSubmitData = async (e) => {
        e.preventDefault();

        // Validate the file input before sending
        if (!file) {
            toast.error("Please select a valid image to upload.");
            return;
        }

        setLoader(true);
        setFileProcessing({ image: true }); // Start processing

        try {
            // Create a FormData object to send the file and other form data
            const formData = new FormData();
            formData.append('image', file);  // Append the image file
            formData.append('title', story?.title);
            formData.append('url', story?.url);
            // Replace `Calling.uploadStoryImage` with the correct API call function
            const resp = await Calling.uploadLiveMatch(formData);

            if (resp.status) {
                toast.success(resp.message);
                // Reset form after successful submission
                fetchData();
            } else {
                toast.error(resp.message);
            }
        } catch (error) {
            toast.error("Something went wrong!");
            console.error(error);
            setFileStatus({ ...fileStatus, image: 'error' }); // Set error status
            navigate('/Error');
        } finally {
            setFile(null);
            setLoader(false);
            setFileStatus({ image: '' })
            setFileProcessing({ image: false }); // Stop processing
        }
    };


    const handleDeleteStory = async (id) => {
        setLoader(true);
        try {
            const content = `You are about to delete Story. To confirm, please solve this math problem`
            const check = genrateCaptch(content);
            if (check) {
                const body = {}
                if (!id) {
                    body.id = selectedUsers;
                } else {
                    body.id = [id];
                }
                const response = await Calling.deleteLiveMatch(body);
                const { status, message } = response;
                if (status) {
                    toast.success(message, { autoClose: 2000 });
                    fetchData();
                    setSelectedUsers([]);
                } else {
                    toast.error(message, { autoClose: 2000 });
                }
            } else {
                toast.error("Ans in not currect", { autoClose: 2000 });

            }
        } catch (error) {
            console.log(error);
            navigate('/Error');
        } finally {
            setLoader(false);
        }
    }


    const handleEditData = (e) => {
        setEditData({ ...editData, [e.target.name]: e.target.value })
    }

    const handleEditeSubmit = async () => {
        setLoader(true);
        try {
            const formData = new FormData();
            formData.append('_id', editData?._id);
            formData.append('title', editData?.title);
            formData.append('url', editData?.url);

            if (editFile) {
                formData.append('image', editFile);
            }

            const resp = await Calling.editLiveMatch(formData);
            if (resp.status) {
                toast.success(resp.message);
                fetchData();
            } else {
                toast.error(resp.message);
            }
            setEditData(null);
        } catch (error) {
            console.log(error);
            navigate('/Error');
        } finally {
            setEditFile(null);
            setFile(null);
            setFileStatus({ image: null });
            setFileProcessing({ image: false });
        }
    }

    const handleselectRecord = (recordId) => {
        setSelectedUsers((prev) => selectedUsers.includes(recordId) ? prev.filter(id => id !== recordId) : [...prev, recordId]);
    }

    const handleViewAnalitic = (id) => {
        navigate(`/views/dashboard/${id}`)
    }

    const handleReset = () => {
        setStory({
            ...story,
            title: '',
            url: '',
            label: 'AD',
        });
        setFile(null);
        setFileStatus({ image: '' })
        setFileProcessing({ image: false }); // Stop processing
    }

    const handleShare = async (id) => {
        const url = `https://test.liveiplmatch.in/live_match/${id}`;

        if (!navigator.clipboard) {
            toast.error('Clipboard API not supported. Please copy manually.', { autoClose: 2000 });
            return;
        }

        try {
            await navigator.clipboard.writeText(url);
            toast.success('Link copied successfully!', { autoClose: 2000 });
        } catch (err) {
            console.error('Failed to copy link: ', err);
            toast.error('Failed to copy link. Please try again.', { autoClose: 2000 });
        }
    };

    const handleCheckboxChange = async (id) => {
        try {
            // Call API to update story ads status
            const content = `You are about to delete Story. To confirm, please solve this math problem`
            const check = genrateCaptch(content);
            if (!check) {
                return toast.error("Ans in not currect", { autoClose: 2000 });
            }
            const resp = await Calling.editLiveMatchStatus(id);
            const { status, message } = resp;

            if (status) {
                toast.success(message)
            } else {
                // Show error message if API returns failure
                toast.error(message);
            }
        } catch (error) {
            // Handle errors like network failure
            navigate('/Error');
            toast.error('Failed to update story video');
        } finally {
            fetchData();
        }
    }

    return (
        <>
            {loader ? (
                <Loader loader={loader} />
            ) : (
                <div className="px-3 sm:ml-[4.4rem] w-full md:mt-20 mt-16 overflow-hidden">
                    <div className="w-full mt-4 mb-2">
                        <h1 className="text-xl sm:text-2xl font-bold">Live Match Management</h1>
                    </div>
                    <div className='bg-main-white rounded-xl'>
                        <NavbarLive selectState={'liveMatch'} />
                        <hr className='mt-2 bg-main-border border-[1px]' />
                        <div className='my-0'>
                            <div className='p-4 md:p-6'>
                                <div className='flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-0 mb-5'>
                                    <h1 className='text-xl md:text-2xl font-bold text-main-font'>Add Live Match</h1>
                                    {secondStoryBrand ?
                                        <span className='px-4 py-1 text-sm rounded-full bg-green-100 text-green-600 flex items-center'><LuDot size={20} /> Running</span> :
                                        <span className='px-4 py-1 text-sm rounded-full bg-red-100 text-red-600 flex items-center'><LuDot size={20} /> Not Running</span>
                                    }
                                </div>
                                <hr className='border-main-border' />

                                <form className='space-y-4 mt-8' encType='multipart/form-data' onSubmit={handleSubmitData}>
                                    <div className='grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-8'>
                                        <div className='grid grid-cols-12 gap-2 items-center lg:col-span-6'>
                                            <label className='col-span-3 lg:col-span-2 text-main-font font-medium'>Title:</label>
                                            <input
                                                type='text'
                                                value={story?.title}
                                                id='title'
                                                name='title'
                                                onChange={handleChangeStory}
                                                className='col-span-9 lg:col-span-10 p-2 border border-main-border rounded-md focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent'
                                                placeholder='Enter Match Title'
                                                required
                                            />
                                        </div>
                                        <div className='grid grid-cols-12 gap-2 items-center lg:col-span-6'>
                                            <label className='col-span-3 lg:col-span-1 text-main-font font-medium'>Url:</label>
                                            <input
                                                type='text'
                                                value={story?.url}
                                                id='url'
                                                name='url'
                                                onChange={handleChangeStory}
                                                className='col-span-9 lg:col-span-11 p-2 border border-main-border rounded-md focus:ring-2 focus:ring-main-subfont focus:outline-none focus:border-transparent'
                                                placeholder='Enter Match Url'
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className='grid grid-cols-12 gap-2'>
                                        <label className='col-span-3 sm:col-span-2 md:col-span-1 text-main-font font-medium'>Image:</label>
                                        <div className='relative col-span-9 sm:col-span-5 md:col-span-3 items-center'>
                                            {fileProcessing['image'] && <div className='absolute inset-0 flex items-center justify-center'><div className='loader'></div></div>}
                                            {fileStatus['image'] === 'error' && <div className='absolute inset-0 flex mt-3 ml-[-20px] text-xl text-red-500'>✘</div>}
                                            {fileStatus['image'] === 'success' && <div className='absolute inset-0 flex mt-3 ml-[-20px] text-xl text-green-500'>✓</div>}

                                            <FileUpload
                                                id='image'
                                                name='image'
                                                accept='image/gif, image/png'
                                                onChange={handleChangefile}
                                                required={true}
                                            />
                                            <p className={`text-[12px] mt-1 ${fileStatus['image'] === 'error' ? 'text-main-delete' : 'text-main-subfont'}`}>
                                                Only PNG and GIF files are allowed.
                                            </p>
                                        </div>
                                    </div>

                                    <div className='grid grid-cols-12 pt-4'>
                                        <div className='col-span-12 sm:col-span-6 md:col-span-4 lg:col-span-3 grid grid-cols-2 gap-3'>
                                            <UploadButton className='w-full' />
                                            <ResetButton className='w-full' onClick={handleReset} />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <hr className='mt-2 border-main-border border-[2px]' />

                        <div>
                            <div>
                                <div className='flex justify-between items-center p-4 md:p-6'>
                                    <h1 className='font-bold text-main-font text-xl md:text-2xl'>Live Match</h1>
                                </div>
                                <div className='overflow-x-auto'>
                                    <table className='w-full rounded-lg overflow-hidden'>
                                        <thead className='bg-main-th text-main-font'>
                                            <tr>
                                                <th className='ps-6 py-3 flex gap-3 mt-1 text-left text-sm font-medium uppercase'>
                                                    <input type='checkbox' onChange={(e) => setSelectedUsers(e.target.checked ? tableData.map(prev => prev._id) : [])} />
                                                    {isNaN(selectedUsers) ? <DeleteButton className=''
                                                        onClick={() => handleDeleteStory()} label={<MdDeleteSweep size={20} />} /> : ''}
                                                </th>
                                                <th className='px-3 py-3 text-left text-sm font-medium uppercase'>No</th>
                                                <th className='px-3 py-3 text-left text-sm font-medium uppercase'>Thumbnail</th>
                                                <th className='px-3 py-3 text-left text-sm font-medium uppercase'>Title</th>
                                                <th className='px-3 py-3 text-left text-sm font-medium uppercase'>Url</th>
                                                <th className='px-3 py-3 text-left text-sm font-medium uppercase'>View</th>
                                                <th className='px-3 py-3 text-left text-sm font-medium uppercase'>Date</th>
                                                <th className='px-3 py-3 text-left text-sm font-medium uppercase'>status</th>
                                                <th className='px-3 py-3 text-left text-sm font-medium uppercase'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className='divide-y divide-gray-200'>
                                            {tableData.length > 0 ?
                                                tableData.map((v, i) => {
                                                    return (
                                                        <tr key={i} className="border-b hover:bg-main-thHover">
                                                            <td className="py-3 w-[6%] text-left px-6">
                                                                <input
                                                                    type="checkbox"
                                                                    name="select"
                                                                    className="cursor-pointer"
                                                                    checked={selectedUsers.includes(v._id)}
                                                                    onChange={(e) => handleselectRecord(v?._id)}
                                                                />
                                                            </td>
                                                            <td className="py-3 px-3 w-[8%] text-left">
                                                                {i + 1}
                                                            </td>
                                                            <td className={`py-3 px-3 w-[8%] text-left ${editData?._id === v?._id ? 'w-[15%]' : ''}`}>
                                                                {editData?._id === v?._id ? (
                                                                    <div className='relative items-left'>
                                                                        <FileUpload
                                                                            id='image'
                                                                            name='image'
                                                                            accept='image/gif, image/png'
                                                                            onChange={handleEditFile}
                                                                            required={true}
                                                                        />
                                                                        {fileProcessing['image'] && <div className='absolute inset-0 flex items-center justify-center'><div className='loader'></div></div>}
                                                                        {fileStatus['image'] === 'error' && <div className='absolute inset-0 flex mt-3 ml-[-20px] text-xl text-red-500'>✘</div>}
                                                                        {fileStatus['image'] === 'success' && <div className='absolute inset-0 flex mt-3 ml-[-20px] text-xl text-green-500'>✓</div>}
                                                                    </div>
                                                                ) : (
                                                                    <img
                                                                        src={v?.thumbnail}
                                                                        alt="logo"
                                                                        className="w-16 h-16 rounded-full object-cover mx-auto"
                                                                    />
                                                                )}
                                                            </td>
                                                            <td className="py-3 px-3 w-[18%]">
                                                                {editData?._id === v?._id ? (
                                                                    <input
                                                                        type="text"
                                                                        name="title"
                                                                        className="border w-full border-main-border rounded py-1 mt-1 ps-2 focus:ring-2 focus:ring-main-subfont focus:outline-none"
                                                                        onChange={handleEditData}
                                                                        value={editData?.title}
                                                                        required
                                                                    />
                                                                ) : (
                                                                    v.title
                                                                )}
                                                            </td>
                                                            <td className={`py-3 px-3 ${editData?._id === v?._id ? 'w-[20%]' : 'w-[5%]'}`}>
                                                                {editData?._id === v?._id ? (
                                                                    <input
                                                                        type="text"
                                                                        name="url"
                                                                        className="border w-full border-main-border rounded py-1 mt-[5px] ps-2 focus:ring-2 focus:ring-main-subfont focus:outline-none"
                                                                        onChange={handleEditData}
                                                                        value={editData?.url}
                                                                        required
                                                                    />
                                                                ) : (
                                                                    <UrlButton url={v?.url} label={<GrLanguage size={24} className="text-main-white" />} />
                                                                )}
                                                            </td>
                                                            <td className="py-3 px-3 w-[10%]">
                                                                <ClickView label={formatView(v?.view)} onClick={() => handleViewAnalitic(v?._id)} />
                                                            </td>
                                                            <td className="py-3 px-3 w-[25%]">
                                                                {formatDateTime(v?.createdAt)}
                                                            </td>
                                                            <td className="py-3 px-3 w-[25%]">
                                                                <div className='flex items-center justify-left ms-2 sm:ms-4 w-full my-2'>
                                                                    <label className="cursor-pointer mt-1">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={v?.status}
                                                                            onChange={(e) => handleCheckboxChange(v?._id)}
                                                                            className="sr-only peer"
                                                                            name='liveMatch'
                                                                        />
                                                                        <div className="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-red-300 dark:peer-focus:ring-red-800 dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-main-white after:border-main-border after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-red-600"></div>
                                                                    </label>
                                                                </div>
                                                            </td>
                                                            {editData?._id === v._id ? (
                                                                <td className="py-3 mt-3 flex items-center space-x-2 px-3">
                                                                    <SaveButton onClick={handleEditeSubmit} />
                                                                    <CancelButton onClick={() => setEditData(null)} />
                                                                </td>
                                                            ) : (
                                                                <td className="py-3 mt-3 flex flex-wrap sm:flex-nowrap items-center gap-2 px-3">
                                                                    <EditButton onClick={() => setEditData(v)} />
                                                                    <DeleteButton onClick={() => handleDeleteStory(v._id)} />
                                                                    <button className='bg-green-500 text-white py-3 px-4 rounded-lg hover:bg-green-400' onClick={() => handleShare(v?._id)}><IoShareSocialOutline /></button>
                                                                </td>
                                                            )}
                                                        </tr>
                                                    );
                                                }) :
                                                <tr><td className='' colSpan={9}><NotFound /></td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default LiveMatch;
